import { theme } from '@frontend/theme';
import { BaseFieldProps, Heading, RadioField } from '@frontend/design-system';
import { CALENDAR_TRACKING_IDS } from '../../trackingIds/calendar-tracking-ids';

type AppointmentStatusFilterListProps = {
  title?: string;
  appointmentStatuses: string[];
  appointmentStatusListProps: BaseFieldProps;
};

export const AppointmentStatusFilterList = ({
  title,
  appointmentStatuses,
  appointmentStatusListProps,
}: AppointmentStatusFilterListProps) => {
  if (!appointmentStatuses?.length) {
    return null;
  }

  return (
    <>
      {title && (
        <Heading level={3} css={{ marginBottom: theme.spacing(2) }}>
          {title}
        </Heading>
      )}
      <RadioField {...appointmentStatusListProps} name='appointment-status-radio-field' label=''>
        {appointmentStatuses.map((status) => {
          return (
            <RadioField.Radio
              key={status}
              value={status}
              css={{ textTransform: 'capitalize' }}
              trackingId={`${CALENDAR_TRACKING_IDS.headerBarFilter.appointmentStatusRadioButton}:${status}`}
            >
              {status}
            </RadioField.Radio>
          );
        })}
      </RadioField>
    </>
  );
};
